import React from "react";
import { connect } from "react-redux";
import BackButton from "../widgets/BackButton";
import {
  getPatientWhatsAppMessagesList,
  markAsReadWMessage,
  sendPatientWhatsappImage,
  sendPatientWhatsAppMessage,
} from "../../actions/patientWhMessagesActions";
import WhatsappImage from "../../assets/images/whatsapp-sender-icon.svg";
import IconAttachImg from "../../assets/images/attach-document.png";
import { getCompanyFormatFullDate } from "../../helpers/DateUtils";

@connect(({ patientWhMessages, whatsappChatting, clinicId }) => {
  return { patientWhMessages, whatsappChatting, clinicId };
})
export class WhatsAppChattingInterface extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      input: "",
      selectedImage: null,
      selectedImagePreview: "",
    };
    this.chatContentRef = React.createRef();
    this.fileInputRef = React.createRef();
  }

  componentDidMount() {
    const { dispatch, location } = this.props;
    const patientKey = new URLSearchParams(location.search).get("pKey");
    dispatch(getPatientWhatsAppMessagesList({ patientKey, limit: 100 }));

    this.pollingInterval = setInterval(() => {
      dispatch(getPatientWhatsAppMessagesList({ patientKey, limit: 100 }));
    }, 60000);

    this.scrollToBottom();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.patientWhMessages.messages !== this.props.patientWhMessages.messages) {
      this.scrollToBottom();
    }
  }

  componentWillUnmount() {
    clearInterval(this.pollingInterval);
  }

  scrollToBottom = () => {
    const { dispatch } = this.props;
    if (this.chatContentRef.current) {
      this.chatContentRef.current.scrollTop = this.chatContentRef.current.scrollHeight;
      const patientKey = new URLSearchParams(this.props.location.search).get("pKey");
      dispatch(markAsReadWMessage({ patientKey }));
    }
  };

  handleInputChange = (e) => {
    this.setState({ input: e.target.value });
  };

  handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);

    this.setState({
      selectedImage: file,
      selectedImagePreview: previewUrl,
    });
  };

  handleSubmitMessage = () => {
    const { input, selectedImage } = this.state;
    const patientKey = new URLSearchParams(this.props.location.search).get("pKey");

    if (!input.trim() && !selectedImage) return; // Hech narsa yuborilmasa — bekor

    if (selectedImage) {
      const formData = new FormData();
      formData.append("patientKey", patientKey);
      formData.append("photo", selectedImage);
      formData.append("caption", input || "");

      this.props.dispatch(sendPatientWhatsappImage(formData)).then(() => {
        this.setState({ input: "", selectedImage: null, selectedImagePreview: "" });
        if (this.fileInputRef.current) this.fileInputRef.current.value = null;

        this.props.dispatch(getPatientWhatsAppMessagesList({ patientKey, limit: 100 }));
      });
    } else {
      this.props.dispatch(sendPatientWhatsAppMessage({ patientKey, text: input })).then(() => {
        this.setState({ input: "" });
        this.props.dispatch(getPatientWhatsAppMessagesList({ patientKey, limit: 100 }));
      });
    }
  };


  render() {
    const { patient } = this.props.whatsappChatting;
    const messages = this.props.patientWhMessages.messages || [];

    return (
      <div style={{ width: "100%", position: "relative" }}>
        <div className="sidebar-header whatsapp-chatting-side-header">
          <div className="clearfix">
            <div className="col-sm-2 pl-1">
              <BackButton
                className="btn-sm pl-0"
                text="Back"
                onClick={this.props.hideWhatsAppChat}
              />
            </div>
            <div className="col-sm-8">
              <div className="whatsapp-note-title text-center">
                <p className="whatsapp-note-title-caption">Messages</p>
                <p className="whatsapp-note-title-chart">Chart#: {patient.chartNumber}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="whatsapp-chatting-content" ref={this.chatContentRef}>
          {messages.map((message, index) => {
            const sentMessage = message.status === "sent";
            return (
              <div key={index} className="whatsapp-chatting-message-wrapper">
                <div
                  className="whatsapp-chatting-message"
                  style={{ marginLeft: sentMessage ? "auto" : undefined }}
                >
                  <div
                    className="whatsapp-chatting-message-content"
                    style={{ backgroundColor: sentMessage ? "#cdd380" : "#dcdcd7" }}
                  >
                    {message?.imageUrl && (
                      <img
                        src={message?.imageUrl}
                        alt="Sent"
                        style={{ maxWidth: 200, borderRadius: 8 }}
                      />
                    )}
                    <p>{message.text}</p>
                  </div>
                  <p
                    className="whatsapp-chatting-message-date"
                    style={{ textAlign: sentMessage ? "right" : "left" }}
                  >
                    {getCompanyFormatFullDate(message.date)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {this.state.selectedImagePreview && (
          <div style={{ position: "absolute", bottom: 60, left: 10 }}>
            <img
              src={this.state.selectedImagePreview}
              alt="Preview"
              style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 4 }}
            />
            <button
              onClick={() => {
                this.setState({ selectedImage: null, selectedImagePreview: "" });
                if (this.fileInputRef && this.fileInputRef.current) {
                  this.fileInputRef.current.value = null;
                }
              }}
              style={{
                position: "absolute",
                top: -8,
                right: -8,
                width: 20,
                height: 20,
                borderRadius: "50%",
                background: "red",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: 12,
                lineHeight: "20px",
                textAlign: "center",
              }}
            >
              ×
            </button>
          </div>
        )}

        <div
          style={{
            display: "flex",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "30px",
              position: "relative",
            }}
          >
            <input
              ref={this.fileInputRef}
              type="file"
              accept="image/*"
              onChange={this.handleImageChange}
              style={{ opacity: 0, position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}
            />
            <img src={IconAttachImg} width={20} height={20} alt="Attach icon" />
          </div>

          <div className="whatsapp-chatting-input-wrapper">
            <input
              type="text"
              value={this.state.input}
              onChange={this.handleInputChange}
              placeholder="Typing..."
              className="whatsapp-chatting-input"
            />
            <img
              onClick={this.handleSubmitMessage}
              className="whatsapp-chatting-sender-icon"
              src={WhatsappImage}
              alt="whatsapp sender"
            />
          </div>
        </div>
      </div>
    );
  }
}
